module.exports = __webpack_public_path__ + "media/images/money-ff1610c457f28a43bd6e24bec05afa3d.svg";